import { render, staticRenderFns } from "./SectionSelectbox.vue?vue&type=template&id=6a26c0b6"
import script from "./SectionSelectbox.vue?vue&type=script&lang=js"
export * from "./SectionSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports